import React, { useEffect, useState } from 'react';
import * as SurveyJs from 'survey-react';
import { ISurveyProps, SurveyOptions, SurveySender } from '../../../types/surveys';

export const SurveyRenderer: React.FC<ISurveyProps> = ({
  surveys,
  surveyName,
  isDueDateOTC,
  handleAfterRenderPage,
  handleCurrentPageChanged,
  handleCurrentPageChanging,
  handleValueChanged,
  onSurveyComplete,
}) => {
  const [surveyData, setData] = useState<SurveyJs.Model | null>(null);
  const [surveyId, setId] = useState<string>('');

  useEffect(() => {
    if (surveys) {
      const survey = new SurveyJs.Model(surveys[0].surveyJson);

      // Hide the survey title
      // TODO: Remove this line when the survey title is removed from the survey JSON on the new onboarding web survey
      survey.title = '';

      if (isDueDateOTC) {
        survey.setValue('user_state', 'less_6_months_pp');
      }

      setData(survey);
      setId(surveys[0].id);
    }
  }, [surveys, isDueDateOTC]);

  return (
    <div id={surveyName} className="survey-content">
      {surveyData !== null ? (
        <SurveyJs.Survey
          onCurrentPageChanged={handleCurrentPageChanged}
          onCurrentPageChanging={handleCurrentPageChanging}
          onAfterRenderPage={handleAfterRenderPage}
          onValueChanged={handleValueChanged}
          model={surveyData}
          onComplete={async (sender: SurveySender, options: SurveyOptions) => {
            await onSurveyComplete(surveyId, sender, options);
          }}
        />
      ) : (
        <p> There is no survey data to display </p>
      )}
    </div>
  );
};

export const Survey = React.memo(SurveyRenderer);
